<div class="row cmg-row-component mb-3">
  @if (!isHTML()) {
    <div class="col col-xl-3 col-lg-4 col-md-5 label" [ngClass]="{ 'fw-semibold': isBoldLabel() }">{{ label() }}</div>
  } @else {
    <div class="col col-xl-3 col-lg-4 col-md-5 label" [ngClass]="{ 'fw-semibold': isBoldLabel() }" [innerHTML]="label()"></div>
  }
  <div class="col col-xl-9 col-lg-8 col-md-7 value">
    <span #ref><ng-content /></span>
    @if (!ref.innerHTML.trim()) {
      <span> -- </span>
    }
  </div>
</div>
